<div class="the_container">

  @if (!isMobileDevice) {
  <div class="d-flex justify-content-between align-items-center find-details-heading">
    <span class="details-text">Find details</span>
  </div>
  }
  <div>
    <!-- <app-dp-tab-menu></app-dp-tab-menu> -->
     <app-dp-tab-menu-v3></app-dp-tab-menu-v3>
  </div>
  <div>
    <router-outlet></router-outlet>
  </div>
</div>